<div class="chip-input-container" [class.disabled]="isDisabled" [class.readonly]="readonly" (click)="focusInput()">
  <div class="chip-input-field" [class.has-chips]="value.length > 0">
    <nz-tag
      *ngFor="let chip of value; let i = index"
      class="chip-item"
      [nzMode]="!readonly && !isDisabled ? 'closeable' : 'default'"
      (nzOnClose)="removeChip(i)"
    >
      {{ chip }}
    </nz-tag>

    <input
      #chipInput
      type="text"
      [placeholder]="value.length > 0 ? '' : placeholder"
      [disabled]="isDisabled"
      [readOnly]="readonly"
      (keydown)="onKeyDown($event)"
      (paste)="onPaste($event)"
      (blur)="onBlur()"
      [(ngModel)]="inputValue"
    />
  </div>
</div>
